module.exports = __webpack_public_path__ + "img/bouton-jouer.e71b6896.png";